import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as offerings from '../../offerings'

export const RESOURCE = {
  payload: {
    description:
      'A phase in a process within an offering that represents a distinct stage or step, such as "Planning", "Execution", or "Evaluation".',
    dimension: offerings.RESOURCE.payload,
    level: 1,
    name: 'Phase',
    partialId: PartialId.Standard.create('phase'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
